/** Default Page Builder config — WordPress-like editable pages + sections */

const WA_CANONICAL = '6281217532692';
const WA_CANONICAL_DISPLAY = '+6281217532692';
const OLD_WA_RE = /6282112923387|6281211737949|\+?62\s*821[-\s]?1292[-\s]?3387|\+?62\s*812[-\s]?1173[-\s]?7949(\s*\(Solo\))?/gi;

function sanitizeContactPhones(content, slug) {
  if (!content || typeof content !== 'object') return content || {};
  if (slug !== '/kontak') return content;
  const next = { ...content };
  ['phone1', 'phone2', 'phone1Wa', 'phone2Wa'].forEach((key) => {
    const val = next[key];
    if (val == null || val === '') {
      if (key === 'phone1' || key === 'phone2') next[key] = WA_CANONICAL_DISPLAY;
      else next[key] = WA_CANONICAL;
      return;
    }
    const str = String(val);
    if (OLD_WA_RE.test(str) || /82112923387|81211737949/.test(str.replace(/\D/g, ''))) {
      next[key] = key.endsWith('Wa') ? WA_CANONICAL : WA_CANONICAL_DISPLAY;
    }
    OLD_WA_RE.lastIndex = 0;
  });
  return next;
}

export const SECTION_TYPES = [
  { type: 'heading', label: 'Judul Section', desc: 'Eyebrow, judul, deskripsi' },
  { type: 'richtext', label: 'Teks / Paragraf', desc: 'Konten teks bebas' },
  { type: 'image', label: 'Gambar', desc: 'Satu gambar penuh' },
  { type: 'image_text', label: 'Gambar + Teks', desc: 'Dua kolom gambar & teks' },
  { type: 'features', label: 'Fitur / Kartu', desc: 'Grid kartu manfaat' },
  { type: 'stats', label: 'Statistik', desc: 'Angka & label' },
  { type: 'cta', label: 'Call to Action', desc: 'Banner ajakan bertindak' },
  { type: 'html', label: 'HTML Kustom', desc: 'Kode HTML bebas' },
  { type: 'products', label: 'Grid Produk', desc: 'Tampilkan produk dari katalog' },
  { type: 'articles', label: 'Grid Artikel', desc: 'Artikel terbaru' },
  { type: 'branches', label: 'Grid Cabang', desc: 'Daftar cabang/agen' },
  { type: 'marketplace', label: 'Marketplace', desc: 'Link Shopee & Tokopedia' },
];

export const SYSTEM_TEMPLATES = [
  { id: 'home', label: 'Beranda' },
  { id: 'about', label: 'Tentang' },
  { id: 'products', label: 'Produk' },
  { id: 'branches', label: 'Agen & Cabang' },
  { id: 'articles', label: 'Artikel' },
  { id: 'contact', label: 'Kontak' },
  { id: 'blank', label: 'Halaman Kosong (CMS)' },
];

const uid = () => `sec_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 7)}`;

export function createSection(type) {
  const base = { id: uid(), type, visible: true };
  switch (type) {
    case 'heading':
      return { ...base, data: { eyebrow: 'Eyebrow', title: 'Judul Section', description: 'Deskripsi singkat section ini.', align: 'center' } };
    case 'richtext':
      return { ...base, data: { content: 'Tulis konten paragraf di sini. Anda bisa mengisi beberapa paragraf.' } };
    case 'image':
      return { ...base, data: { src: 'https://images.unsplash.com/photo-1633509817627-5a29634475af?w=1200&q=80', alt: 'Gambar', caption: '' } };
    case 'image_text':
      return {
        ...base,
        data: {
          eyebrow: 'Profil',
          title: 'Judul Kolom Teks',
          body: 'Paragraf deskriptif untuk mendampingi gambar.',
          image: 'https://images.unsplash.com/photo-1633509817627-5a29634475af?w=900&q=80',
          imagePosition: 'left',
          badgeValue: '12+',
          badgeLabel: 'Tahun',
        },
      };
    case 'features':
      return {
        ...base,
        data: {
          items: [
            { title: 'Fitur 1', items: 'Poin A\nPoin B\nPoin C' },
            { title: 'Fitur 2', items: 'Poin A\nPoin B' },
            { title: 'Fitur 3', items: 'Poin A\nPoin B' },
          ],
        },
      };
    case 'stats':
      return {
        ...base,
        data: {
          items: [
            { value: '18 Th', label: 'Tahun Pengalaman' },
            { value: '100+', label: 'Varian Rasa' },
            { value: '100%', label: 'Halal BPOM' },
          ],
          style: 'banner',
        },
      };
    case 'cta':
      return {
        ...base,
        data: {
          title: 'Siap Mulai?',
          description: 'Hubungi tim kami untuk konsultasi gratis.',
          buttonText: 'Chat WhatsApp',
          buttonUrl: '',
          style: 'green',
        },
      };
    case 'html':
      return { ...base, data: { html: '<div class="text-center py-8"><p>Konten HTML kustom</p></div>' } };
    case 'products':
      return { ...base, data: { eyebrow: 'Produk', title: 'Varian Pilihan', description: 'Produk favorit pelanggan.', limit: 6 } };
    case 'articles':
      return { ...base, data: { eyebrow: 'Artikel', title: 'Tips & Insight', description: 'Artikel terbaru.', limit: 3 } };
    case 'branches':
      return { ...base, data: { eyebrow: 'Cabang', title: 'Temukan Kami', description: 'Kunjungi toko cabang kami.', limit: 3 } };
    case 'marketplace':
      return {
        ...base,
        data: {
          eyebrow: 'Marketplace',
          title: 'Belanja Lebih Mudah',
          description: 'Temukan produk kami di marketplace favorit.',
          image: '/images/marketplace-belbel.jpg',
        },
      };
    default:
      return { ...base, data: {} };
  }
}

export const DEFAULT_PAGES = {
  '/': {
    name: 'Beranda',
    slug: '/',
    status: 'published',
    template: 'home',
    isSystem: true,
    title: 'Beranda',
    subtitle: '',
    content: {
      heroBadge: 'Sejak 2013 · Bubuk Minuman Premium',
      heroTitle: 'Bubuk Minuman Premium Terlengkap',
      heroSubtitle: 'Bikin pelangganmu repeat order hanya dengan bubuk minuman premium terlengkap dari BelBel (Sidoarjo Powder).',
      heroImage: 'https://images.unsplash.com/photo-1633509817627-5a29634475af?w=900&q=80',
      featuresEyebrow: 'Tentang BelBel (Sidoarjo Powder)',
      featuresTitle: 'Supplier Bubuk Minuman Premium',
      featuresDescription: 'BelBel adalah brand bubuk minuman dengan kualitas premium. Diproduksi menggunakan bahan baku bermutu tinggi dan diproses secara higienis oleh tenaga produksi profesional.',
      productsEyebrow: 'Produk BelBel',
      productsTitle: 'Varian Rasa Pilihan',
      productsDescription: 'Beberapa varian favorit yang paling dicintai pelanggan kami. Kualitas premium tanpa filler, tanpa pengawet, tanpa pewarna kimia.',
      marketplaceEyebrow: 'Temukan di Marketplace Favoritmu!',
      marketplaceTitle: 'Belanja BelBel Lebih Mudah & Lebih Murah',
      marketplaceDescription: 'Pastikan voucher dari marketplace favoritmu tidak hangus sia-sia dan dapatkan produk pilihan BelBel secara mudah dan tentunya dengan harga terbaik.',
      marketplaceImage: '/images/marketplace-belbel.jpg',
      testimonialsEyebrow: 'Testimonial',
      testimonialsTitle: 'Cerita Mitra BelBel',
      testimonialsDescription: 'Sejak 2013, BelBel telah dipercaya oleh banyak pelaku usaha minuman UMKM, franchise/kemitraan, agen/grosir bubuk minuman.',
      branchesEyebrow: 'Toko Cabang',
      branchesTitle: 'Temukan BelBel secara Langsung!',
      branchesDescription: 'Kunjungi toko cabang kami di berbagai kota untuk konsultasi produk & pembelian langsung.',
      articlesEyebrow: 'Artikel & Tips',
      articlesTitle: 'Insight untuk Bisnis Minuman Anda',
      articlesDescription: 'Baca artikel terbaru seputar tips bisnis minuman, resep signature, dan panduan produk BelBel.',
      ctaTitle: 'Siap Kembangkan Bisnis Minuman Anda?',
      ctaDescription: 'Konsultasi gratis dengan tim BelBel untuk mendapatkan penawaran terbaik untuk usaha minuman Anda.',
      ctaButton: 'Chat WhatsApp Sekarang',
    },
    sections: [],
  },
  '/tentang': {
    name: 'Tentang BelBel',
    slug: '/tentang',
    status: 'published',
    template: 'about',
    isSystem: true,
    title: 'Tentang BelBel (Sidoarjo Powder)',
    subtitle: 'Supplier bubuk minuman premium dengan komitmen menghadirkan produk berkualitas tinggi untuk pertumbuhan bisnis mitra kami.',
    content: {
      profileEyebrow: 'Profil Perusahaan',
      profileTitle: 'Bubuk Minuman Premium untuk Bisnis Berkualitas',
      profileBody1: 'BelBel (Sidoarjo Powder) adalah brand bubuk minuman dengan kualitas premium yang telah dipercaya sejak 2013. BelBel diproduksi menggunakan bahan baku bermutu tinggi dan diproses secara higienis oleh tenaga produksi profesional, sehingga menghasilkan bubuk minuman (powder drink) yang berkualitas.',
      profileBody2: 'Kami berkomitmen untuk selalu melakukan inovasi dalam menciptakan varian rasa yang sesuai dengan selera pasar. Beberapa varian BelBel yang dicintai masyarakat yaitu cappucino, coklat, teh (thai tea, matcha green tea), milkshake, buah-buahan, dan masih banyak lagi.',
      profileImage: 'https://images.unsplash.com/photo-1633509817627-5a29634475af?w=900&q=80',
      badgeValue: '18 Th',
      badgeLabel: 'Tahun Pengalaman',
      visiTitle: 'Visi',
      visiText: 'Menjadi supplier bubuk minuman premium nomor 1 di Indonesia yang dipercaya oleh jutaan pelaku usaha minuman.',
      misiTitle: 'Misi',
      misiText: 'Menghadirkan produk berkualitas premium dengan harga terjangkau, layanan responsif, dan inovasi rasa yang mengikuti tren pasar.',
      nilaiTitle: 'Nilai Kami',
      nilaiText: 'Kejujuran, kualitas premium tanpa kompromi, dan kemitraan jangka panjang yang saling menguntungkan.',
      featuresEyebrow: 'Kualitas & Sertifikasi',
      featuresTitle: 'Kenapa Memilih BelBel?',
      featuresDescription: 'Setiap produk BelBel memenuhi standar kualitas premium dan telah bersertifikat resmi.',
    },
    sections: [],
  },
  '/produk': {
    name: 'Produk',
    slug: '/produk',
    status: 'published',
    template: 'products',
    isSystem: true,
    title: 'Produk Bubuk Minuman',
    subtitle: 'Temukan varian rasa premium terlengkap dari BelBel untuk bisnis minuman Anda.',
    content: {},
    sections: [],
  },
  '/agen': {
    name: 'Agen & Cabang',
    slug: '/agen',
    status: 'published',
    template: 'branches',
    isSystem: true,
    title: 'Agen & Cabang BelBel',
    subtitle: 'Temukan lokasi toko cabang dan agen resmi BelBel di seluruh Indonesia.',
    content: {
      ctaTitle: 'Ingin Menjadi Agen BelBel?',
      ctaDescription: 'Gabung bersama kami dan kembangkan bisnis bubuk minuman Anda.',
      ctaButton: 'Chat WhatsApp',
    },
    sections: [],
  },
  '/artikel': {
    name: 'Artikel',
    slug: '/artikel',
    status: 'published',
    template: 'articles',
    isSystem: true,
    title: 'Artikel & Tips',
    subtitle: 'Insight bisnis minuman, resep, dan panduan produk BelBel.',
    content: {},
    sections: [],
  },
  '/kontak': {
    name: 'Kontak',
    slug: '/kontak',
    status: 'published',
    template: 'contact',
    isSystem: true,
    title: 'Hubungi Kami',
    subtitle: 'Ada pertanyaan atau ingin konsultasi? Tim BelBel siap membantu Anda.',
    content: {
      infoTitle: 'Informasi Kontak',
      officeLabel: 'Kantor Pusat',
      address: 'PONDOK MUTIARA MEK 28 - 30, Banjarbendo, Kec. Sidoarjo, Kabupaten Sidoarjo.',
      phoneLabel: 'Telepon / WhatsApp',
      phone1: '+6281217532692',
      phone1Wa: '6281217532692',
      phone2: '+6281217532692',
      phone2Wa: '6281217532692',
      emailLabel: 'Email',
      email: 'info@belbel.co.id',
      hoursLabel: 'Jam Operasional',
      hours: 'Senin - Sabtu: 08.00 - 17.00 WIB',
      hoursNote: 'Minggu: Libur',
      formTitle: 'Kirim Pesan',
      formDescription: 'Isi form di bawah dan tim BelBel akan menghubungi Anda dalam 1x24 jam.',
      formSuccess: 'Terima kasih. Tim BelBel akan segera menghubungi Anda.',
      instagram: 'https://www.instagram.com/belbel.powder',
      waButtonText: 'WhatsApp',
    },
    sections: [],
  },
};

/** Merge saved page_builder with defaults (backward compatible with old title/subtitle-only shape) */
export function resolvePageBuilder(saved) {
  const pages = {};
  const savedPages = saved?.pages || {};

  Object.keys(DEFAULT_PAGES).forEach((slug) => {
    const def = DEFAULT_PAGES[slug];
    const cur = savedPages[slug] || {};
    pages[slug] = {
      ...def,
      ...cur,
      slug,
      isSystem: true,
      template: def.template,
      content: sanitizeContactPhones({ ...def.content, ...(cur.content || {}) }, slug),
      sections: Array.isArray(cur.sections) ? cur.sections : def.sections,
    };
    // backward compat: home hero from legacy key
    if (slug === '/' && saved?.home) {
      if (saved.home.heroTitle) pages[slug].content.heroTitle = saved.home.heroTitle;
      if (saved.home.heroSubtitle) pages[slug].content.heroSubtitle = saved.home.heroSubtitle;
    }
  });

  // Custom pages (not in defaults)
  Object.keys(savedPages).forEach((slug) => {
    if (pages[slug]) return;
    const cur = savedPages[slug];
    pages[slug] = {
      name: cur.name || slug,
      slug,
      status: cur.status || 'published',
      template: cur.template || 'blank',
      isSystem: false,
      title: cur.title || cur.name || 'Halaman',
      subtitle: cur.subtitle || '',
      content: cur.content || {},
      sections: Array.isArray(cur.sections) ? cur.sections : [],
    };
  });

  return { ...(saved || {}), pages };
}

export function getPage(pageBuilder, slug) {
  const resolved = resolvePageBuilder(pageBuilder);
  return resolved.pages[slug] || null;
}

export function slugifyPath(name) {
  const base = String(name || 'halaman')
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9\s-]/g, '')
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-')
    .slice(0, 48) || 'halaman';
  return `/${base}`;
}

export function createBlankPage(name = 'Halaman Baru', path) {
  const slug = path || slugifyPath(name);
  return {
    name,
    slug,
    status: 'published',
    template: 'blank',
    isSystem: false,
    title: name,
    subtitle: 'Deskripsi singkat halaman ini.',
    content: {},
    sections: [
      createSection('heading'),
      createSection('richtext'),
    ],
  };
}

/** Content field defs for system templates (admin form) */
export const TEMPLATE_CONTENT_FIELDS = {
  home: [
    { key: 'heroBadge', label: 'Hero Badge' },
    { key: 'heroTitle', label: 'Hero Title' },
    { key: 'heroSubtitle', label: 'Hero Subtitle', multiline: true },
    { key: 'heroImage', label: 'Hero Image', type: 'image' },
    { key: 'featuresEyebrow', label: 'Fitur — Eyebrow' },
    { key: 'featuresTitle', label: 'Fitur — Judul' },
    { key: 'featuresDescription', label: 'Fitur — Deskripsi', multiline: true },
    { key: 'productsEyebrow', label: 'Produk — Eyebrow' },
    { key: 'productsTitle', label: 'Produk — Judul' },
    { key: 'productsDescription', label: 'Produk — Deskripsi', multiline: true },
    { key: 'marketplaceEyebrow', label: 'Marketplace — Eyebrow' },
    { key: 'marketplaceTitle', label: 'Marketplace — Judul' },
    { key: 'marketplaceDescription', label: 'Marketplace — Deskripsi', multiline: true },
    { key: 'marketplaceImage', label: 'Marketplace — Gambar', type: 'image' },
    { key: 'testimonialsEyebrow', label: 'Testimonial — Eyebrow' },
    { key: 'testimonialsTitle', label: 'Testimonial — Judul' },
    { key: 'testimonialsDescription', label: 'Testimonial — Deskripsi', multiline: true },
    { key: 'branchesEyebrow', label: 'Cabang — Eyebrow' },
    { key: 'branchesTitle', label: 'Cabang — Judul' },
    { key: 'branchesDescription', label: 'Cabang — Deskripsi', multiline: true },
    { key: 'articlesEyebrow', label: 'Artikel — Eyebrow' },
    { key: 'articlesTitle', label: 'Artikel — Judul' },
    { key: 'articlesDescription', label: 'Artikel — Deskripsi', multiline: true },
    { key: 'ctaTitle', label: 'CTA — Judul' },
    { key: 'ctaDescription', label: 'CTA — Deskripsi', multiline: true },
    { key: 'ctaButton', label: 'CTA — Teks Tombol' },
  ],
  about: [
    { key: 'profileEyebrow', label: 'Profil — Eyebrow' },
    { key: 'profileTitle', label: 'Profil — Judul' },
    { key: 'profileBody1', label: 'Profil — Paragraf 1', multiline: true },
    { key: 'profileBody2', label: 'Profil — Paragraf 2', multiline: true },
    { key: 'profileImage', label: 'Profil — Gambar', type: 'image' },
    { key: 'badgeValue', label: 'Badge Angka' },
    { key: 'badgeLabel', label: 'Badge Label' },
    { key: 'visiTitle', label: 'Visi — Judul' },
    { key: 'visiText', label: 'Visi — Teks', multiline: true },
    { key: 'misiTitle', label: 'Misi — Judul' },
    { key: 'misiText', label: 'Misi — Teks', multiline: true },
    { key: 'nilaiTitle', label: 'Nilai — Judul' },
    { key: 'nilaiText', label: 'Nilai — Teks', multiline: true },
    { key: 'featuresEyebrow', label: 'Fitur — Eyebrow' },
    { key: 'featuresTitle', label: 'Fitur — Judul' },
    { key: 'featuresDescription', label: 'Fitur — Deskripsi', multiline: true },
  ],
  products: [],
  branches: [
    { key: 'ctaTitle', label: 'CTA — Judul' },
    { key: 'ctaDescription', label: 'CTA — Deskripsi', multiline: true },
    { key: 'ctaButton', label: 'CTA — Teks Tombol' },
  ],
  articles: [],
  contact: [
    { key: 'infoTitle', label: 'Judul Panel Info' },
    { key: 'officeLabel', label: 'Label Alamat (mis. Kantor Pusat)' },
    { key: 'address', label: 'Alamat', multiline: true },
    { key: 'phoneLabel', label: 'Label Telepon' },
    { key: 'phone1', label: 'Telepon 1 (tampilan)' },
    { key: 'phone1Wa', label: 'Telepon 1 — nomor WA (628xxx)' },
    { key: 'phone2', label: 'Telepon 2 (tampilan)' },
    { key: 'phone2Wa', label: 'Telepon 2 — nomor WA (628xxx)' },
    { key: 'emailLabel', label: 'Label Email' },
    { key: 'email', label: 'Email' },
    { key: 'hoursLabel', label: 'Label Jam Operasional' },
    { key: 'hours', label: 'Jam Operasional', multiline: true },
    { key: 'hoursNote', label: 'Catatan Jam (mis. Minggu: Libur)' },
    { key: 'instagram', label: 'Link Instagram' },
    { key: 'waButtonText', label: 'Teks Tombol WhatsApp' },
    { key: 'formTitle', label: 'Judul Form' },
    { key: 'formDescription', label: 'Deskripsi Form', multiline: true },
    { key: 'formSuccess', label: 'Pesan Sukses', multiline: true },
  ],
  blank: [],
};
